import { Box, Fab, Tooltip, useTheme } from '@mui/material';
import { Plus } from 'lucide-react';

interface FloatingActionButtonProps {
  onClick: () => void;
}

const FloatingActionButton = ({ onClick }: FloatingActionButtonProps) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        marginRight: theme.spacing(2),
        transition: 'all 0.2s ease',
        zIndex: 1300 // Ensure it's above the sidebar
      }}
    >
      <Tooltip title="Add Workstream" placement="left">
        <Fab
          color="primary"
          onClick={onClick}
          size="large"
          sx={{
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'scale(1.05)'
            },
            '&:active': {
              transform: 'scale(0.95)'
            }
          }}
        >
          <Plus size={24} />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default FloatingActionButton;